import React from 'react'

import { Widget } from '@typeform/embed-react'
import { Typography } from '@telavita-core/react-design-kit'

import { usePatientEmotionalHealthEvaluation } from 'hooks'

import PatientAlreadyCompletedMessage from './components/PatientAlreadyCompletedMessage/PatientAlreadyCompletedMessage'

import * as S from './styles'

const MedicalEvaluation = (): JSX.Element => {

  const { formId, uuid, showNotification, isLoading } = usePatientEmotionalHealthEvaluation()

  const patientHasAlreadyCompleted = !showNotification

  return (
    <S.Container>
      <Typography variant='header2' customClassName='MedicalEvaluation__Title'>
        Avaliação de saúde emocional
      </Typography>
      <S.EmbedWrapper patientHasAlreadyCompleted={patientHasAlreadyCompleted}>
        {!isLoading && patientHasAlreadyCompleted && <PatientAlreadyCompletedMessage />}
        {!isLoading && !patientHasAlreadyCompleted && (
          <Widget 
            inlineOnMobile
            id={formId}
            className="MedicalEvaluation__Form" 
            fullScreen={false}
            hidden={{
              emotional_health_evaluation_uuid: uuid
            }}
          />
        )}
      </S.EmbedWrapper>
      {!patientHasAlreadyCompleted && (
        <Typography variant='content2' customClassName='MedicalEvaluation__Disclaimer'>
          <b>Importante:</b> Essa avaliação não é um diagnóstico e não exclui a avaliação com um profissional especialista.
        </Typography>
      )}
    </S.Container>
  )
}

export default MedicalEvaluation